module.exports = __webpack_public_path__ + "img/3.beffa8cc.png";